module.exports = __webpack_public_path__ + "static/gs-d2a141cb116aaaba0ed142c6506ff25e.png";